module.exports = __webpack_public_path__ + "img/Clients.b2945bfe.svg";